module.exports = __webpack_public_path__ + "img/9788932918235.0228ee30.jpg";